import { Stack } from "@mui/material";

import Item from "../../Item";

export default function SegundaEtapa({ data }) {
  const listData = [
    {
      column_1: {
        label: "Faz uso de ventilação não invasiva?",
        value: data.ventilacaoNaoInvasivaBIPAP,
      },
      column_2: {
        label: "Data do início",
        value: data.bipapDataInicio,
      },
      column_3: {
        label: "Duração",
        value: data.bipapDuracao,
      },
    },
    {
      column_1: {
        label: "Faz uso de traqueostomia?",
        value: data.traquestomia,
      },
      column_2: {
        label: "Data do início",
        value: data.traqueostomiaDataInicio,
      },
      column_3: {
        label: "Tipo de procedimento",
        value: data.traqueostomiaProcedimento,
      },
    },
    {
      column_1: {
        label: "Faz uso de gastrostomia?",
        value: data.gastrostomia,
      },
      column_2: {
        label: "Data do início",
        value: data.gastrostomiaDataInicio,
      },
      column_3: {
        label: "",
        value: "",
      },
    },
    {
      column_1: {
        label: "Faz uso de alimentação por sonda?",
        value: data.sondaNasogastrica,
      },
      column_2: {
        label: "Data do início",
        value: data.sondaNasogastricaDataInicio,
      },
      column_3: {
        label: "",
        value: "",
      },
    },
    {
      column_1: {
        label: "Faz uso de cough assist?",
        value: data.coughAssist,
      },
      column_2: {
        label: "",
        value: "",
      },
      column_3: {
        label: "",
        value: "",
      },
    },
    {
      column_1: {
        label: "Tecnologia de comunicação?",
        value: data.tecnologiaComunicacao,
      },
      column_2: {
        label: "",
        value: "",
      },
      column_3: {
        label: "",
        value: "",
      },
    },
    {
      column_1: {
        label: "Faz uso de assistência domiciliar?",
        value: data.assistenciaDomiciliar,
      },
      column_2: {
        label: "",
        value: "",
      },
      column_3: {
        label: "",
        value: "",
      },
    },
    {
      column_1: {
        label: "Multidisciplinaridade oferecida?",
        value: data.multidisciplinar,
      },
      column_2: {
        label: "Quais?",
        value: data.multidisciplinarTipo?.map((item) => item + " "),
      },
      column_3: {
        label: "",
        value: "",
      },
    },
    {
      column_1: {
        label: "Faz uso de cadeira de rodas?",
        value: data.usoCadeiraDeRodas,
      },
      column_2: {
        label: "Tipo de procedimento",
        value: data.tipoProcedimento,
      },
      column_3: {
        label: "",
        value: "",
      },
    },
  ];
  return (
    <Stack>
      {listData.map((item, index) => {
        const isGrid =
          item.column_1.label !== "Faz uso de cough assist?" &&
          item.column_1.label !== "Tecnologia de comunicação?" &&
          item.column_1.label !== "Faz uso de assistência domiciliar?";
        if (isGrid) {
          return (
            <Stack className="template-grid column-3" key={index}>
              <Item label={item.column_1.label} text={item.column_1.value} />
              <Item label={item.column_2.label} text={item.column_2.value} />
              <Item label={item.column_3.label} text={item.column_3.value} />
            </Stack>
          );
        } else {
          return (
            <Stack mb="15px" key={index}>
              <Item label={item.column_1.label} text={item.column_1.value} />
            </Stack>
          );
        }
      })}
    </Stack>
  );
}
